module.exports = __webpack_public_path__ + "static/media/img29.fed4768f.jpeg";